function tickAnswers(answ) {
  answ.forEach(item => {
    if (item.textContent.includes('*')) {
      item.previousSibling.classList.add('is_right');
    } else {
      item.previousSibling.classList.add('is_wrong');
    }

    item.textContent = item.textContent.replace(/\*/g, '');
  });
}

function untick(ti) {
  ti.forEach(item => {
    item.classList.remove('ticked');
  });
}

function showTestItem(ti, index) {
  ti.forEach(item => {
    item.classList.remove('show');
    item.classList.add('hide');
  });

  try {
    ti[index - 1].classList.remove('hide');
    ti[index - 1].classList.add('show');
  } catch(e) {}
}

function showOrder(num, ti) {
  num.forEach((item, i) => {
    item.prepend(i + 1 + '/' + ti.length);
  });
}

function clearAnswers(answers) {
  answers.forEach(answer => {
    answer.innerHTML = '? ';
    answer.parentElement.classList.remove('right');
  });
}

function clearBackground(t) {
  t.forEach(tick => {
    tick.parentElement.classList.remove('right');
    tick.parentElement.classList.remove('wrong');
  });
}

function clearTicksContent(t) {
  t.forEach(tick => {
    tick.textContent = ' ';
  });
}

function showTicksContent(t) {
  t.forEach(tick => {
    tick.textContent = '? ';
  });
}

function showDescr(item, content) {
  if (content.textContent != '') {
    item.parentNode.append(content);
  }
}

function answered(answ) {
  answ.classList.add('ticked');
}

function showNextBtn(index, ti, btn) {
  if (index < ti.length) {
    btn.classList.remove('hide');
  }
}

function showFinishBtn(index, ti, btn) {
  if (index == ti.length) {
    btn.classList.remove('hide');
  }
}

function hideNextBtn(btn) {
  btn.classList.add('hide');
}

export { tickAnswers };
export { untick };
export { showTestItem };
export { showOrder };
export { clearAnswers };
export { clearBackground };
export { clearTicksContent };
export { showTicksContent };
export { showDescr };
export { answered };
export { showNextBtn };
export { showFinishBtn };
export { hideNextBtn };